module.exports = __webpack_public_path__ + "media/images/plans/photo_location/photo_location-2-3-32bf09338efaffcc8a02e09e907c135b.png";